module.exports = __webpack_public_path__ + "img/landing_followup.15e619d7.svg";